import React from "react";
import { AffiliateStatus, Partner, PurchaseRuleLink, SelectionState, XolaPartnerStatus } from "types";
import shallow from "zustand/shallow";
import { useAutoFetchCollection } from "../../../hooks/useAutoFetchCollection";
import { useCollection } from "../../../hooks/useCollection";
import { getPurchaseRulesFromPurchaseRuleLinks } from "../../../models/PurchaseRuleLink";
import { TableSkeleton } from "../../Common/Skeleton/TableSkeleton";
import { PartnerCommissionsFilter } from "./PartnerCommissionsFilter";
import { PartnerCommissionsList } from "./PartnerCommissionsList";
import { useSeller } from "@/hooks/useAccount";
import { usePartnerCommissionsFilterStore } from "@/stores/reports/partnerCommissionsFilterStore";

export const PartnerCommissions = () => {
    const seller = useSeller();
    const [filters] = usePartnerCommissionsFilterStore((state) => [state.filters], shallow);
    const { data: allPartners, isLoading: isLoadingPartners } = useAutoFetchCollection<Partner>(["partners"], {
        seller: seller.id,
    });
    // TODO create one type for partner status
    const partners = allPartners.filter(
        (partner) => partner.status === XolaPartnerStatus.ACCEPTED || partner.status === AffiliateStatus.ACTIVE,
    );

    const { data: termsTemplates, isLoading: isLoadingTermsTemplates } = useCollection<PurchaseRuleLink>(
        "purchaseRuleLinks",
        { "tags._id": "Affiliate", expand: "purchaseRule" },
    );

    const handlePartnersFilterChange = (value: SelectionState): Partner[] => {
        if (value.all || (!value.all && value.selected.length === 0)) {
            return partners;
        }

        if (value.selected.length > 0) {
            return partners?.filter((partner) => value.selected.includes(partner.id));
        }

        return partners;
    };

    const purchaseRules = getPurchaseRulesFromPurchaseRuleLinks(termsTemplates);
    const isLoading = isLoadingPartners || isLoadingTermsTemplates;

    return (
        <div>
            <PartnerCommissionsFilter partners={partners} />
            {isLoading ? (
                <TableSkeleton rows={7} columns={5} />
            ) : (
                <PartnerCommissionsList
                    partners={handlePartnersFilterChange(filters.partners)}
                    termsTemplates={termsTemplates}
                    purchaseRules={purchaseRules}
                />
            )}
        </div>
    );
};
